import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MobileResponsiveService } from 'src/app/services/mobile-view/mobile-responsive.service';
import { OrgStructureServService } from '../org-structure-serv.service';

@Component({
  selector: 'app-org-struct-color-palatte',
  templateUrl: './org-struct-color-palatte.component.html',
  styleUrls: ['./org-struct-color-palatte.component.scss'],
})
export class OrgStructColorPalatteComponent  implements OnInit {
  
  buttonColor:any;
  orgStructColors: any = {
    orgStructNameColor: '#F6921E',
    orgStructDepartmentColor: '#F6921E',
    orgStructBgColor: '#F6921E',
    orgStructBorderColor: '#F6921E',
    orgStructSubbordinateBgColor: '#F6921E',
    orgStructSubbordinateTextColor: '#F6921E',
    orgStructInitialsBgColor: '#F6921E',
    orgStructInitialsTextColor: '#F6921E'
  }
  
  constructor( @Inject(MAT_DIALOG_DATA) public data: any, public dialogRef: MatDialogRef<OrgStructColorPalatteComponent>, public dialog: MatDialog, public mobileResponsiveService: MobileResponsiveService, private orgStructureServService: OrgStructureServService ) { }
  
  ngOnInit() {
    this.orgStructColors = this.data;
  }
  
  onOrgStructColorChange(event: any, targetName: string){
    this.orgStructColors[targetName] = event.target.value;
  }  
  
  btn1Action(){
    this.dialogRef.close(false);
  }
  btn2Action(){
    this.dialogRef.close(this.orgStructColors);
  }
  onClickDefault(){
    this.dialogRef.close(this.orgStructureServService.orgStructDefaultColors);
  }
  
}
